import React, { useEffect, useRef, useState } from "react";
import AdminSidebar from './AdminSidebar'
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import iziToast from 'izitoast';

const ContactUsDetails = () => {

  const navigate = useNavigate();
  const { apipath } = useAuth();
  const [contactData, setContactData] = useState([]);

  // Function to fetch Contact data
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apipath}/contact/details`);
      setContactData(response.data.contactUs || []);
    } catch (error) {
      console.error('Error fetching contactUs:', error);
    }
  };

   // Function to handle contactUs deletion
  const handleDelete = async (contactId) => {
    try {
      const response = await axios.delete(`${apipath}/contact/details/${contactId}`);
      
      if (response.status === 200) {
        // Update the state to remove the deleted contact from the UI
        setContactData(prevContacts => prevContacts.filter(contact => contact._id !== contactId));
        
        // Show success notification
        iziToast.success({
          message: "Details deleted successfully",
          position: "topCenter",
        });
        
        navigate("/contactUsDetails");
      } else {
        // Show error notification if deletion failed
        iziToast.error({
          message: "details deletion failed",
          position: "topCenter",
        });
      }
    } catch (error) {
      console.error('Error deleting contact:', error);
      // Show error notification if an error occurred
      iziToast.error({
        message: "An error occurred while deleting the contact",
        position: "topCenter",
      });
    }
  };


  const handleUpdate = async (contactId) => {
    try {
      // Redirect to the user details page with the productId as a parameter
      navigate(`/contactEdit/${contactId}`);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
        <AdminSidebar />
        <div className="home">
        <div class="toggle-sidebar" style={{ display: "none" }}>
          <i class="bi bi-menu"></i>
        </div>
        <div className="dashboard">
          <div className="dashboard-header">
            <h1>Contact Management</h1>
          </div>

          <div className="container-fluid">          
          <div className='filter-flex'>
            <div class="input-group search-group">
              <div class="input-group-prepend search-prepend">
                <span class="input-group-text search-text" id="basic-addon1">
                  <i className="bi bi-search"></i>
                </span>
              </div>
              <input
                type="text"
                class="form-control search-control"
                placeholder="Search by name"
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            </div>
            <div className="row foot-tablerow">
              <div className="col-lg-11 maintable-column">
                <div className="container mt-4">
                  <table id="datatable" className="table">
                    <thead>
                      <tr className="tr1">
                      <th>S.No.</th>
                        <th>Name</th>
                        <th>Phone No.</th>
                        <th>Email Id</th>
                        <th>companyName</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contactData.map((contact, index) => (
                        <tr key={contact._id}>
                        <td>{index + 1}</td>
                          <td>{contact.name}</td>
                          <td>{contact.phoneNo}</td>
                          <td>{contact.email}</td>
                          <td>{contact.companyName}</td>
                          <td>
                          <button className="table-btn me-2"
                              onClick={() => handleUpdate(contact._id)}>
                              <i className="bi bi-pencil"></i>
                            </button>
                            <button className="table-btn" onClick={() => handleDelete(contact._id)}>
                              <i className="bi bi-trash"></i>
                            </button>
                        </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUsDetails